export enum AdminBurnInTestsRoutes {
  Search = 'search',
}
